import { useMemo, useReducer } from 'react'

import { Portfolio, PortfolioFormPayload } from 'types'

import { paveApi } from 'api'
import {
  portfolioFormReducer,
  setInitialPortfolioForm,
} from 'components/reducers/portfolioFormReducer'
import PDSCard from 'designSystem/components/PDSCard/PDSCard'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import { SIZE } from 'designSystem/foundations/constants/size'
import { formatToPortfolioForm } from 'utils/portfolioFormUtil'

import InvestmentPreferenceChangesSection from './InvestmentPreferenceChangesSection'
import PortfolioInvestmentPreferencesForm from './PortfolioInvestmentPreferencesForm'

type Props = {
  initialPortfolio: Portfolio
  handleSubmitForm: (portfolio: PortfolioFormPayload) => void
  isDisabled: boolean
  submitEditPortfolioForm: (
    portfolioPayload: PortfolioFormPayload
  ) => Promise<void>
}

export default function InvestmentPreferenceFormAndComparisonSections({
  initialPortfolio,
  handleSubmitForm,
  isDisabled,
  submitEditPortfolioForm,
}: Props) {
  const { managementOrganizationId } = initialPortfolio.clientAccount
  const { data: benchmarks } = paveApi.useGetBenchmarksQuery()
  const { data: buyLists } = paveApi.useGetBuyListNamesQuery()
  const { data: templatesResponse } =
    paveApi.useGetManagementOrganizationInvestmentTemplatesQuery(
      managementOrganizationId || '',
      {
        skip: !managementOrganizationId,
        refetchOnMountOrArgChange: true,
      }
    )
  const initialPortfolioFormData = useMemo(() => {
    return formatToPortfolioForm(initialPortfolio, false)
  }, [initialPortfolio])
  const [formState, dispatch] = useReducer(
    portfolioFormReducer,
    initialPortfolioFormData
  )

  const undoAllChanges = () => {
    dispatch(setInitialPortfolioForm(initialPortfolioFormData))
  }

  return (
    <>
      <PDSFlexBox gap={SIZE.s20}>
        <PDSCard width="41rem">
          <PortfolioInvestmentPreferencesForm
            initialPortfolio={initialPortfolio}
            formState={formState}
            dispatch={dispatch}
            showLoader={isDisabled}
            handleSubmitForm={handleSubmitForm}
          />
        </PDSCard>
      </PDSFlexBox>

      <InvestmentPreferenceChangesSection
        submitEditPortfolioForm={submitEditPortfolioForm}
        formState={formState}
        initialPortfolioFormData={initialPortfolioFormData}
        benchmarks={benchmarks || []}
        buyLists={buyLists || []}
        templates={templatesResponse?.investmentPreferencesTemplates || []}
        undoAllChanges={undoAllChanges}
      />
    </>
  )
}
